const featuredProductContainer = document.querySelectorAll(".featured_product_ak");
const shapeOptionBlocks = document.querySelectorAll(".shape_options");


shapeOptionBlocks.forEach(shapeOptionBlock => {
shapeOptionBlock.addEventListener('click', (e) => {
var url = new URL("https://memoryblock.com.au/pages/fathers-day-2024");
const clicked = e.target.closest(".shape_options_link");
if(!clicked) return null;
featuredProductContainer.forEach( fpc => fpc.classList.remove("featured_product--active") );
document.querySelector(`.featured_product--${ clicked.dataset.product }`).classList.add("featured_product--active");
window.location.hash = `${ clicked.dataset.product }`;
});
});












